export default "__VITE_ASSET__BrwfI9Gr__"